(function () {
    angular.module('tmx-app').controller('scanDocumentDialog', ['$scope', '$mdDialog', '$timeout', scanDocumentDialog]);
    function scanDocumentDialog($scope, $mdDialog, $timeout) {
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.scan = function () {};
        // $scope.scan = function () {
        //     var DWObject = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainer'); // Get the Dynamic Web TWAIN object that is embeded in the div with id 'dwtcontrolContainer'.
        //     DWObject.IfDisableSourceAfterAcquire = true;    // Source will be closed automatically after acquisition.
        //     var bSelected = DWObject.SelectSource();                        // Select a Data Source (a device like scanner) from the Data Source Manager.

        //     if (bSelected) {
        //         var OnAcquireImageSuccess, OnAcquireImageFailure;
        //         OnAcquireImageFailure = function () {
        //             DWObject.CloseSource();
        //         };

        //         OnAcquireImageSuccess = function () {
        //             var count = DWObject.HowManyImagesInBuffer;
        //             DWObject.ConvertToBase64([count - 1], EnumDWT_ImageType.IT_JPG, asyncSuccessFunc, asyncFailureFunc);
        //             function asyncSuccessFunc(result) {
        //                 var length = result.getLength();
        //                 $timeout(function(){
        //                     $scope.scannedImage = 'data:image/jpeg;base64,' + result.getData(0, length);
        //                 });
        //             }
        //             function asyncFailureFunc(errorCode, errorString) {
        //                 $timeout(function(){
        //                     $scope.error = "ErrorCode: " + errorCode + "\r" + "ErrorString:" + errorString;
        //                 });
        //             }
        //         }

        //         DWObject.OpenSource();                          // Open the source. You can set resolution, pixel type, etc. after this method. Please refer to the sample 'Scan' -> 'Custom Scan' for more info.
        //         DWObject.AcquireImage(OnAcquireImageSuccess, OnAcquireImageFailure);                        // Acquire image(s) from the Data Source. Please NOTE this is a asynchronous method. In other words, it doesn't wait for the Data Source to come back. 
        //         // In order to do things during the scanning, you can use the events OnPostTransfer and OnPostAllTransfers. Please check out the sample UseEvent.html
        //     }
        // }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.done = function () {
            if ($scope.scannedImage) {
                $mdDialog.hide($scope.scannedImage);
            }
            else {
                $scope.error = "Please scan the document"
            }
        };
    }
})();